<template>
    <div class="video-container hidden sm:block">
        <video
            v-if="!isMobile"
            ref="backgroundVideo"
            class="absolute w-full h-full top-0 left-0 -z-10 object-cover"
            :autoplay="isPlaying" muted loop>
            <source :src="video.src" :type="video.type"/>
        </video>
        <button
            v-if="!isMobile"
            type="button"
            class="absolute bottom-8 right-8 h-8 px-4 py-2 bg-[#2c241a] rounded-[21px] justify-center items-center gap-2 inline-flex text-white text-xs font-semibold font-['Lato']"
            @click="toggleVideo">
            <PauseIcon v-if="isPlaying" class="-ml-0.4 size-4" aria-hidden="true" />
            <PlayIcon v-if="!isPlaying" class="-mr-0.4 size-4" aria-hidden="true" />
            {{ isPlaying ? $t("elements.video.pause") : $t("elements.video.play") }}
        </button>
    </div>
</template>

<script>

import {
    PauseIcon,
    PlayIcon,
} from "@heroicons/vue/20/solid"
import { ref, onMounted, onBeforeUnmount } from "vue"

export default {
    name: "VideoBackground",
    components: {
        PauseIcon,
        PlayIcon,
    },
    props: {
        video: {
            type: Object,
            required: true,
        }
    },
    setup() {
        const isMobile = ref(window.innerWidth < 576)

        const updateIsMobile = () => {
            isMobile.value = window.innerWidth < 576
        }

        onMounted(() => {
            window.addEventListener("resize", updateIsMobile)
        })

        onBeforeUnmount(() => {
            window.removeEventListener("resize", updateIsMobile)
        })

        return {
            isMobile,
        }
    },
    data() {
        return {
            isPlaying: true,
        }
    },
    methods: {
        toggleVideo() {
            this.isPlaying = !this.isPlaying
            const video = this.$refs.backgroundVideo
            if (this.isPlaying) {
                video.play()
            } else {
                video.pause()
            }
        }
    },
}
</script>
